import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from '../rtkQuery';
import { restApiFormData } from '../axios';
import { API_ENDPOINTS } from '../constants';

export const locationsAPI = createApi({
    reducerPath: 'locationsAPI',
    baseQuery: axiosBaseQuery(restApiFormData),
    endpoints: (builder) => ({
        searchLocations: builder.mutation({
            query: (query) => ({
                url: `${API_ENDPOINTS.SEARCH_LOCATION_ACTION}?${query.toString()}`,
                method: 'POST',
            }),
        }),
        listLocations: builder.mutation({
            query: (query) => ({
                url: `${API_ENDPOINTS.LOCATIONS}?${query.toString()}`,
                method: 'POST',
            }),
        }),
        newLocation: builder.mutation({
            query: (data) => ({
                url: API_ENDPOINTS.NEW_LOCATION,
                method: 'POST',
                data,
            }),
        }),
        modifyLocation: builder.mutation({
            query: (data) => ({
                url: API_ENDPOINTS.MODIFY_LOCATION,
                method: 'POST',
                data,
            }),
        }),
        newLocationAction: builder.mutation({
            query: (data) => ({
                url: API_ENDPOINTS.NEW_LOCATION_ACTION,
                method: 'POST',
                data,
            }),
        }),
        modifyLocationAction: builder.mutation({
            query: (data) => ({
                url: API_ENDPOINTS.MODIFY_LOCATION_ACTION,
                method: 'POST',
                data,
            }),
        }),
        deleteLocation: builder.mutation({
            query: (data) => ({
                url: API_ENDPOINTS.DELETE_LOCATION,
                method: 'POST',
                data,
            }),
        }),
        viewLocation: builder.mutation({
            query: (data) => ({
                url: API_ENDPOINTS.VIEW_LOCATION,
                method: 'POST',
                data,
            }),
        }),
    }),
});

export const {
    useSearchLocationsMutation,
    useListLocationsMutation,
    useNewLocationMutation,
    useModifyLocationMutation,
    useNewLocationActionMutation,
    useModifyLocationActionMutation,
    useDeleteLocationMutation,
    useViewLocationMutation,
} = locationsAPI;
